<div
  [class]="getElementClasses()"
  ngClass="widtget-editor-text"
  [style.text-align]="widget?.textAlign || 'left'"
  [innerHTML]="widget?.Texto"
></div>
